import React from "react";
import { Stack, Group, ActionIcon, Text, ColorInput, Box } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";

const COLOR_PLACEHOLDER_BACKGROUND = "#FFD6EE";
const COLOR_PLACEHOLDER_TEXT = "#0000FF";

interface ColorsSectionProps {
  backgroundColor: string;
  textColor: string;
  onBackgroundColorChange: (color: string) => void;
  onTextColorChange: (color: string) => void;
  onBack: () => void;
}

const ColorsSection: React.FC<ColorsSectionProps> = ({
  backgroundColor,
  textColor,
  onBackgroundColorChange,
  onTextColorChange,
  onBack,
}) => {
  return (
    <Stack gap="md">
      <Group justify="space-between" align="center">
        <ActionIcon variant="subtle" onClick={onBack}>
          <IconChevronLeft size={16} />
        </ActionIcon>
        <Text fw={600} size="lg">
          Colors
        </Text>
      </Group>

      <Stack gap="sm">
        <Box>
          <Text size="sm" fw={500} mb="xs">
            Background Color
          </Text>
          <ColorInput
            value={backgroundColor}
            onChange={onBackgroundColorChange}
            placeholder={COLOR_PLACEHOLDER_BACKGROUND}
          />
        </Box>

        <Box>
          <Text size="sm" fw={500} mb="xs">
            Text Color
          </Text>
          <ColorInput
            value={textColor}
            onChange={onTextColorChange}
            placeholder={COLOR_PLACEHOLDER_TEXT}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default ColorsSection;
